import React from 'react';
import { Link } from 'react-router-dom';

import { Button, Typography } from '@mui/material';

interface NavbarLogoProps {
  label: string;
  url: string;
}

const NavbarLogo: React.FunctionComponent<NavbarLogoProps> = ({
  label,
  url,
}) => {
  return (
    <Typography
      variant='h6'
      noWrap
      component='div'
      sx={{ mr: 2, display: { md: 'flex' } }}
    >
      <Link to={url}>
        <Button sx={{ my: 2, color: 'white', display: 'block' }}>
          {label}
        </Button>
      </Link>
    </Typography>
  );
};

export default NavbarLogo;
